import type { RumInitConfiguration } from '@datadog/browser-rum'

const MAX_DATADOG_RUM_SESSION_SAMPLE_RATE = 10
const MAX_DATADOG_REPLAY_SESSION_SAMPLE_RATE = 1
const DATADOG_TRACE_SAMPLE_RATE = 1

type DatadogRumCostConfiguration = Pick<
  RumInitConfiguration,
  'sessionSampleRate' | 'sessionReplaySampleRate' | 'traceSampleRate' | 'traceContextInjection'
>

/**
 * Creates the Datadog RUM settings that limit billable session and trace volume.
 * @param {number} requestedSessionSampleRate RUM session rate requested by the remote flag.
 * @param {number} requestedSessionReplaySampleRate Replay rate requested by the remote flag.
 * @returns {DatadogRumCostConfiguration} Cost-controlled Datadog RUM settings.
 */
export function createDatadogRumCostConfiguration(
  requestedSessionSampleRate: number,
  requestedSessionReplaySampleRate: number
): DatadogRumCostConfiguration {
  return {
    traceSampleRate: DATADOG_TRACE_SAMPLE_RATE,
    traceContextInjection: 'sampled',
    sessionSampleRate: Math.min(requestedSessionSampleRate, MAX_DATADOG_RUM_SESSION_SAMPLE_RATE),
    sessionReplaySampleRate: Math.min(requestedSessionReplaySampleRate, MAX_DATADOG_REPLAY_SESSION_SAMPLE_RATE)
  }
}
